// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "rescript/lib/es6/caml_obj.js";

var cardNumberOptions_validations = [
  "required",
  "validCardNumber"
];

var cardNumberOptions_showCardIcon = true;

var cardNumberOptions = {
  type: "card-number",
  name: "card_number",
  placeholder: "1234 1234 1234 1234",
  validations: cardNumberOptions_validations,
  showCardIcon: cardNumberOptions_showCardIcon
};

function cardExpiryOptions(expiryPlaceholder) {
  return {
          type: "card-expiration-date",
          name: "card_exp",
          placeholder: expiryPlaceholder,
          validations: [
            "required",
            "validCardExpirationDate"
          ],
          showCardIcon: false,
          yearLength: 2
        };
}

var cardCvcOptions_validations = [
  "required",
  "validCardSecurityCode"
];

var cardCvcOptions_showCardIcon = true;

var cardCvcOptions = {
  type: "card-security-code",
  name: "card_cvc",
  placeholder: "123",
  validations: cardCvcOptions_validations,
  showCardIcon: cardCvcOptions_showCardIcon
};

var savedCardCvcCss = Object.fromEntries([
        [
          "padding",
          "0px"
        ],
        [
          "margin",
          "0px"
        ],
        [
          "line-height",
          "1.8rem"
        ],
        [
          "height",
          "1.8rem"
        ],
        [
          "box-sizing",
          "border-box"
        ]
      ].map(function (param) {
          return [
                  param[0],
                  param[1]
                ];
        }));

var newrecord = Caml_obj.obj_dup(cardCvcOptions);

newrecord.css = savedCardCvcCss;

newrecord.showCardIcon = false;

var vgsScriptURL = "https://js.verygoodvault.com/vgs-collect/2.27.2/vgs-collect.js";

var savedCardCvcOptions = newrecord;

export {
  vgsScriptURL ,
  cardNumberOptions ,
  cardExpiryOptions ,
  cardCvcOptions ,
  savedCardCvcCss ,
  savedCardCvcOptions ,
}
/* savedCardCvcCss Not a pure module */
